
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anthropic-api-ui-for-web-developers",
      function () {
        return require("private-next-pages/anthropic-api-ui-for-web-developers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anthropic-api-ui-for-web-developers"])
      });
    }
  